import React from 'react'
import { Statistic } from 'semantic-ui-react'
import { connect } from 'react-redux'

const NumImprovisers = ({ numImprovisers }) => (
    <Statistic label='Improvvisatori' value={numImprovisers} />
)

const mapStateToProps = (state) => ({
    numImprovisers: state.numImprovisers
})

export default connect(
    mapStateToProps
)(NumImprovisers)



// WEBPACK FOOTER //
// ./src/components/NumImprovisers.js